import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[appGridContentTemplate]'
})
export class GridContentTemplateDirective { }
